import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { BulkImportSteper } from "./BulkImportSteper";
import BulkImportStep1 from "./BulkImportStep1";
import BulkImportStep2 from "./BulkImportStep2";
import BulkImportStep3 from "./BulkImportStep3";
import ResultModal from "../Common/ResultModal";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { AuthContext } from "../../Contexts/AuthContext";
import SpinnerLoading from "../Common/SpinnerLoading";
import { itemServices } from "../../Services/item.service";
import { roles } from "../../Config/Roles";

const BulkImport = ({ match }) => {
  const priceListId = match.params.priceListId;
  const { locName, locTenant, locStore, locPos } = useContext(GlobalContext);
  const { roleId } = useContext(AuthContext);
  const { cashier, accountant, manager } = roles;
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(false);
  const { t: translator } = useTranslation();
  const [step, setStep] = useState(1);
  const [data, setData] = useState();
  const [dataForImport, setDataForImport] = useState();
  const [generalError, setGeneralError] = useState();
  const [serverErrors, setServerErrors] = useState();
  const [localErrors, setLocalErrors] = useState();

  const [resultModal, setResultModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
  });

  useEffect(() => {
    if ([cashier, manager, accountant].includes(Number(roleId)))
      history.push("/error-page/401");
    setIsLoading(true);
    if (data) {
      // provjeravamo da li ima zapisa, ako nema...
      if (data?.data?.length === 0) {
        setGeneralError("Datoteka nema zapisa za uvoz.");
        return;
      }

      // provjeravamo da li header odgovara očekivanom formatu
      let headerKeys = [];
      // headerKeys.push(translator("Id"));
      headerKeys.push(translator("BulkImport-StepOne-Data-Name"));
      //headerKeys.push(translator("BulkImport-StepOne-Data-Code"));
      //headerKeys.push(translator("BulkImport-StepOne-Data-BarCode"));
      //headerKeys.push(translator("BulkImport-StepOne-Data-Description"));
      headerKeys.push(translator("BulkImport-StepOne-Data-IsService"));
      headerKeys.push(translator("BulkImport-StepOne-Data-Pn"));
      headerKeys.push(translator("BulkImport-StepOne-Data-UnitOfMeasure"));
      //headerKeys.push(translator("BulkImport-StepOne-Data-TaxRate"));
      headerKeys.push(translator("BulkImport-StepOne-Data-ItemGroup"));
      headerKeys.push(translator("BulkImport-StepOne-Data-Price"));
      headerKeys.push(translator("BulkImport-StepOne-Data-Pp"));
      //headerKeys.push(translator("BulkImport-StepOne-Data-ClassNumber"));

      const dataHeaderKeys = Object.keys(data?.data?.[0]);
      let missingKeys = [];
      headerKeys.forEach((k) => {
        if (!dataHeaderKeys.includes(k)) {
          missingKeys.push(k);
        }
      });

      if (missingKeys.length > 0) {
        setGeneralError(
          `${translator(
            "BulkImport-StepOne-Data-wrongData"
          )} ${missingKeys.join(", ")}`
        );
        return;
      }

      let localValidationErrors = [];
      const isServiceAllowedValues = ["da", "ne"];

      const importData = data.data.map((d, i) => {
        let _errorList = [];
        let isService =
          d[translator("BulkImport-StepOne-Data-IsService")].toLowerCase();

        if (!isService || !isServiceAllowedValues.includes(isService)) {
          _errorList.push(
            `${translator(
              "BulkImport-StepOne-DataData"
            )} "${isService}" ${translator(
              "BulkImport-StepOne-Column"
            )} "${translator(
              "BulkImport-StepOne-Data-IsService"
            )}" ${translator("BulkImport-StepOne-AllowedValues")}`
          );
        }

        if (_errorList.length > 0) {
          localValidationErrors.push({ index: i, errors: _errorList });
        }

        return {
          id: d[translator("Id")],
          name: d[translator("BulkImport-StepOne-Data-Name")],
          code: d[translator("BulkImport-StepOne-Data-Code")],
          barCode: d[translator("BulkImport-StepOne-Data-BarCode")],
          description: d[translator("BulkImport-StepOne-Data-Description")],
          isService: isService === "da",
          unitOfMeasure: d[translator("BulkImport-StepOne-Data-UnitOfMeasure")],
          taxRate: d[translator("BulkImport-StepOne-Data-TaxRate")],
          itemGroup: d[translator("BulkImport-StepOne-Data-ItemGroup")],
          price: d[translator("BulkImport-StepOne-Data-Price")],
          pp: d[translator("BulkImport-StepOne-Data-Pp")],
          pn: d[translator("BulkImport-StepOne-Data-Pn")],
          classNumber: d[translator("BulkImport-StepOne-Data-ClassNumber")],
        };
      });

      if (localValidationErrors.length > 0) {
        setLocalErrors(localValidationErrors);
        setIsLoading(false);
        setStep(step + 1);
        return;
      }

      // serverska validacija
      itemServices
        .bulkImportValidate({
          tenantId: Number(locTenant),
          priceListId: Number(priceListId),
          data: importData.map((p) => {
            return {
              ...p,
              price: parseFloat(p.price.replace(",", ".")),
              pn: parseFloat(p.pn.replace(",", ".")),
              pp: parseFloat(p.pp.replace(",", ".")),
            };
          }),
        })
        .then((res) => {
          if (res.data.success) {
            setDataForImport(res.data.data);
          } else {
            setServerErrors(res.data.errors);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setIsLoading(false);
          setStep(step + 1);
        });
    }
  }, [data]);

  const handleImport = () => {
    itemServices
      .bulkImport({
        tenantId: Number(locTenant),
        priceListId: Number(priceListId),
        data: dataForImport,
      })
      .then((res) => {
        res.data.success
          ? setResultModal({
            show: true,
            title: translator("Bulkimport-SuccessModal-Title"),
            text: translator("Bulkimport-SuccessModal-Text"),
            btnClass: "btn btn-primary",
          })
          : setResultModal({
            show: true,
            title: translator("Bulkimport-UnsuccessModal-Title"),
            text: translator("Bulkimport-UnsuccessModal-Text"),
            btnClass: "btn btn-danger",
          });
      })
      .catch((err) => {
        setResultModal({
          show: true,
          title: translator("Bulkimport-UnsuccessModal-Title"),
          text: translator("Bulkimport-UnsuccessModal-Text"),
          btnClass: "btn btn-danger",
        });
      });
  };

  const handleCloseResultModal = () => {
    setResultModal({ show: false });
    goBack();
  };

  const goBack = () => {
    switch (locName) {
      case "stores":
        history.push(`/${locName}/${locStore}`);
        break;
      case "pos":
        history.push(`/${locName}/${locPos}`);
        break;
      default:
        history.push("/error");
    }
  };

  const nextStep = () => {
    setStep(step + 1);
  };

  const prevStep = () => {
    setDataForImport([]);
    setStep(step - 1);
  };

  switch (step) {
    case 1:
      return (
        <BulkImportSteper
          step={step}
          subtitle={translator("Bulkimport-SteperSubtitle-MassImportOfItems")}
          progress="20"
        >
          <BulkImportStep1
            setData={setData}
            handleCancel={goBack}
            generalError={generalError}
          />
        </BulkImportSteper>
      );
    case 2:
      return (
        <BulkImportSteper
          step={step}
          subtitle={translator("BulkImport-SteperSubtitle-DataVerification")}
          progress="40"
        >
          {isLoading && (
            <div className="dashboard-card-spinner">
              <SpinnerLoading />
            </div>
          )}
          {!isLoading && (
            <BulkImportStep2
              data={data}
              serverErrorList={serverErrors}
              localErrorList={localErrors}
              setServerErrors={setServerErrors}
              prevStep={prevStep}
              nextStep={nextStep}
            />
          )}
        </BulkImportSteper>
      );
    case 3:
      return (
        <>
          <BulkImportSteper
            step={step}
            subtitle={translator("Bulkimport-SteperSubtitle-Save")}
            progress="60"
          >
            <BulkImportStep3 prevStep={prevStep} handleImport={handleImport} />
          </BulkImportSteper>
          <ResultModal
            show={resultModal.show}
            title={resultModal.title}
            text={resultModal.text}
            btnClass={resultModal.btnClass}
            handleClose={handleCloseResultModal}
          />
        </>
      );
    default:
      return <></>;
  }
};

export default BulkImport;
